import { TransfersOmniService } from '../transfers-omni.service';
import { TransfersOmniEventType } from '../transfers-omni.event.type';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TweenMax, Quint } from 'gsap';
import { Auth } from '../../../autentication/Auth';
import { Transfer } from '../../models/transfer';
import { BenefactorDataModel } from '../../models/benefactorData';
import { EventTypes } from '../../../shared/EventTypes';
import { MatTableDataSource, MatSort } from '@angular/material';
import { Util } from '../../../utils/util';

@Component({
	selector: 'app-favored-data-omni',
	templateUrl: './favored-data-omni.component.html',
	styleUrls: ['./favored-data-omni.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class FavoredDataOmniComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() submited = false;
	@Input() transferData: Transfer;

	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

	public agency = '';

	public form: FormGroup;
	private view = '[data-component="favored-data-omni"]';

	private viewHeight = 0;
	public hideDestinationAgency: boolean = false;

	active = true;

	destinationAccount;
	destinationAccountOld;

	favoredSelected;

	favoredAccountError = false;

	dataSource: MatTableDataSource<BenefactorDataModel>;
	displayedColumns = ['name', 'cpf', 'account', 'modality', 'check'];
	isLoadingBenefactors = true;

	constructor(private formBuilder: FormBuilder, private transferOmniService: TransfersOmniService) {

		this.form = formBuilder.group({
			'remember': [false],
			'favoredSelect': [null],
			'destinationAccountBuilder': this.formBuilder.group({
				'destinationAccount': [null, Validators.required]
			}, {validator: this.sameDestinationAccount}),
		});

	}

	ngOnInit() {
		AppEventDispatcher.listen(TransfersOmniEventType.STEPS.FAVORED_DATA, data => {
			if (data.show) {
				this.getBenefactors();
				this.setForm.emit(this.form);
			} else {
				this.hide();
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(TransfersOmniEventType.STEPS.FAVORED_DATA);
	}

	show() {
		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			this.viewHeight = containerHeight;

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut });
		});
	}

	hide() {
		if (!this.favoredSelected) {
			this.setTransferData();
		} else {
			this.setTransferDataWithFavoredSelected();
		}

		TweenMax.to(this.view, 2.8, {
			left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}
		});
	}

	getBenefactors() {
		this.preload(true);
		this.transferOmniService.getBenefactors().subscribe(dados => {
			this.dataSource = new MatTableDataSource(dados);
			this.isLoadingBenefactors = false;
			this.preload(false);
			this.show();
		}, error => {
			this.isLoadingBenefactors = false;
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	setTransferData() {
		this.transferData.destinationAccount = this.form.get(['destinationAccountBuilder', 'destinationAccount']).value.replace(/\D/g, '');
		this.transferData.favoredRemember = this.form.controls.remember.value;
	}

	setTransferDataWithFavoredSelected() {
		this.transferData.destinationAccount = this.favoredSelected.accountNumber.replace(/\D/g, '');
		this.transferData.favoredRemember = false;
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight();
	}


	showTab(tab) {
		let containerHeight: number;

		if (tab.index === 1) {
			containerHeight = this.getStepHeight() + 30;
			this.form.controls.favoredSelect.setValidators(Validators.required);
			this.form.controls.favoredSelect.updateValueAndValidity();

			this.form.get(['destinationAccountBuilder', 'destinationAccount']).clearValidators();
			this.form.get(['destinationAccountBuilder', 'destinationAccount']).updateValueAndValidity();

			this.changeFavored();

		} else {
			containerHeight = this.viewHeight;

			this.favoredSelected = false;

			this.form.controls.favoredSelect.clearValidators();
			this.form.controls.favoredSelect.updateValueAndValidity();

			this.form.get(['destinationAccountBuilder', 'destinationAccount']).setValidators(Validators.required);
			this.form.get(['destinationAccountBuilder', 'destinationAccount']).updateValueAndValidity();

			this.form.controls.destinationAccountBuilder.setValidators(this.sameDestinationAccount);
			this.form.controls.destinationAccountBuilder.updateValueAndValidity();
		}

		TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
	}

	changeFavored() {
		this.favoredSelected = this.form.controls.favoredSelect.value;
	}

	applyFilter(filterValue: string) {
		this.dataSource.filter = filterValue.trim().toLowerCase();
	}

	sameDestinationAccount(c: AbstractControl): { invalid: boolean} {
		if (c.get('destinationAccount').value !== null && c.get('destinationAccount').value !== undefined) {
			if (c.get('destinationAccount').value.replace('-', '') === Auth.getInstance().getUser().accountNumber.toString()) {
				return {invalid: true};
			}
		}
	}

	destinationAccountMask(event) {
		if (event.keyCode === 8) {
		} else 	if (event.target.value.length <= 21) {
			// remove all mask characters (keep only numeric)
			let newVal = event.target.value.replace(/\D/g, '');


			// don't show braces for empty value
			if (newVal.length === 0) {
				newVal = '';
			} else  {
				newVal = newVal.replace(/^(\d{0,20})*(\d{1})/, '$1-$2');
			}

			// set the new value
			this.destinationAccountOld = this.destinationAccount = newVal;
		} else {
			this.destinationAccount = this.destinationAccountOld;
		}
	}

	maskCpfCpnj(cpfCnpj: string): string{
		return Util.maskCpfCnpjPix(cpfCnpj);
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="transfers-omni"] .content', show: active, delay: delay });
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transfers-omni/favored-data-omni/favored-data-omni.component.ts